export default function throttleUtil (func, wait) {
  let lastCallTime = 0
  return function (...args) {
    const now = Date.now()
    if (now - lastCallTime >= wait) {
      lastCallTime = now
      func.apply(this, args)
    }
  }
}
